import React from 'react'
import { Box } from 'rebass'
import styled from 'styled-components'

const ModalWrapper = styled(Box)`
  z-index: 2;
  background-color: #2c3037;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ModalBackground = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
`

const ModalPosition = styled(Box)`
  background-color: white;
  margin: auto;
  border-radius: 4px;
  border: 1px solid #e9eaeb;
  z-index: 101;
  max-width: 100%;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  min-width: 220px;
`

const ModalContent = styled(Box)`
  width: 600px;
  min-height: 400px;
  max-width: 100%;
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  display: flex;
  flex-direction: column;
`

const ModalBody = styled(Box)`
  -webkit-overflow-scrolling: touch;
  flex-grow: 1;
  display: flex;
  overflow: auto;
  overflow-x: hidden;
`

export default class Modal extends React.Component {
  modalBackgroundRef = React.createRef()

  render () {
    return (
      <>
        <ModalWrapper id='modal-wrapper' style={this.props.modalWrapperStyle || {}}>
          <ModalBackground
            className='modal-background'
            ref={this.modalBackgroundRef}
          />
          <ModalPosition className='modal-position'>
            <ModalContent id='modal' style={this.props.modalStyle || {}}>
              <ModalBody className={`modal-body ${this.props.className || ''}`} style={this.props.modalBodyStyle || {}}>
                {this.props.children}
              </ModalBody>
            </ModalContent>
          </ModalPosition>
        </ModalWrapper>
        <style global jsx>{`
          ${this.props.projectStyles}
        `}</style>
      </>
    )
  }
}
